import { ISpotBase } from '../../models/spots';
import { IVentureBase } from '../../models/ventures';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListSpotProps {
  isActive?: boolean;
  name?: string;
  sort?: 'name' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export interface ISpotListItem extends ISpotBase {
  venture: IVentureBase;
}

export type ISpotList = IListResponse<ISpotListItem>;

export const listSpotsService = async (
  filters?: IListSpotProps,
): Promise<ISpotList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          isActive: filters.isActive,
          name: filters.name || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<ISpotList>('/spots', {
    params,
  });

  return data;
};
